export enum LoadStatusTypes {
  Arrived = 1,
  InTransit = 2,
  Departed = 3,
  Delivered = 4,
  Appointment = 5,
  Estimate = 6,
}
